import { useMutation } from "@tanstack/react-query";

import { client } from "@/config/client";

export const useReset = function (id) {
  const mutationFn = () => {
    return client.users.reset(id);
  };
  return useMutation({
    mutationFn,
  });
};
